import React from 'react'
import { FormattedMessage } from 'react-intl'

export const HEAD_PLAYER_TITLE = (
    <FormattedMessage
        id="clanmanagement.memberstable.head.player.title"
        defaultMessage="Игрок"
    />
)

export const PLAYER_STATUS_ONLINE = (
    <FormattedMessage
        id="clanmanagement.memberstable.player.status.online"
        defaultMessage="В сети"
    />
)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/translations.js